import React, { Component } from 'react';
import FbrService from '../service/FbrService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { SplitButton } from 'primereact/splitbutton';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'moment/locale/fr';
import moment from 'moment';

export class FormJournalPayement extends Component {
    constructor() {
        super();
        this.state = {
            pd1:  new Date(moment(new Date()).format('YYYY') + '-01-01'),
            pd2: new Date(),
            ridPrest: null,
            ridObj: null,
            totalFacture: '0',
            liste_data: [],
            listeprest: [],
            listeobj: [],
            items: [
                {
                    label: 'Format PDF',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.conf_print('PDF');
                    }
                },
                {
                    label: 'Format XLS',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.conf_print('XLS');
                    }
                },
                {
                    label: 'Format CSV',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.dt.exportCSV();
                    }
                }
            ],
            showindicator: false,
            userconnected: JSON.parse(localStorage.getItem('userconnected')),
        };
        this.conf_print = this.conf_print.bind(this);
        this.FbrService = new FbrService();
    }


    conf_print(format) {
        let spd1 = moment(this.state.pd1).format('MM/YYYY');
        let spd2 = moment(this.state.pd2).format('MM/YYYY');
        let ridpres = 'Tous';
        let rfacture = 'Tous';
        if (this.state.ridPrest !== undefined && this.state.ridPrest !== null) {
            ridpres = this.state.ridPrest;
        }
        if (this.state.ridObj !== undefined && this.state.ridObj !== null) {
            rfacture = this.state.ridObj;
        }
        this.FbrService.generer_edition_journal_payement(spd1, spd2, ridpres, rfacture, format);
    }


    get_liste_prestataire() {
        this.setState({ showindicator: true });
        this.FbrService.get_liste_prestataire_eval().then(data => {
            this.setState({ showindicator: false });
            if (data !== null && data !== undefined && data !== '') {
                if (data.length > 0) {
                    let liste = data.map(x => {
                        return { value: x.idPrest, label: x.nomPrest }
                    });
                    this.setState({ listeprest: liste });
                }
            }
        });
    }

    get_liste_facture_by_prest(ridPrest) {
        this.setState({ showindicator: true });
        this.FbrService.get_liste_objectif('Tous', 'Tous', ridPrest, 'Tous', 'Tous').then(data => {
            this.setState({ showindicator: false });
            if (data.length > 0) {
                let liste = data.map(x => {
                    return { value: x.idObj, label: 'No ' + x.idObj + ' ' + x.periodeObj + ' ' + x.nomPrest }
                });
                this.setState({ listeobj: liste });
            }
        });
    }

    get_liste_data() {
        let spd1 = moment(this.state.pd1).format('MM/YYYY');
        let spd2 = moment(this.state.pd2).format('MM/YYYY');
        let ridpres = 'Tous';
        let rfacture = 'Tous';
        if (this.state.ridPrest !== undefined && this.state.ridPrest !== null) {
            ridpres = this.state.ridPrest;
        }
        if (this.state.ridObj !== undefined && this.state.ridObj !== null) {
            rfacture = this.state.ridObj;
        }
        this.setState({ showindicator: true });
        this.FbrService.get_journal_payement(spd1, spd2, ridpres, rfacture).then(data => {
            this.setState({ liste_data: data, showindicator: false });
            if (data !== null && data !== undefined) {
                if (data.length > 0) {
                    let initialValue = 0;
                    let tt = data.reduce(function (accumulator, currentValue) {
                        return accumulator + currentValue.montantRgl
                    }, initialValue);
                    this.setState({ totalFacture: this.FbrService.formaterValueSep(tt) });
                }
            }
        });
    }

    componentDidMount() {
        this.get_liste_prestataire();
        this.get_liste_data();
    }


    render() {
        const hTotal = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <label style={{ fontSize: 18 }}>TOTAL</label>
            <label style={{ fontWeight: 'bold', color: 'red', fontSize: 18 }}>{this.state.totalFacture}</label>
        </div>
        return (
            <div className="card p-fluid">
                <div className="grid">
                    <div className="col-12">
                        <div className="card-w-title">
                            <i className="pi pi-search"></i> Option de recherche
                            <hr />
                            <div className="grid">
                                <div className="col-12 md:col-2">
                                    <Calendar value={this.state.pd1} onChange={(e) => this.setState({ pd1: e.value }, () => {
                                        this.get_liste_data();
                                    })} view="month" dateFormat="mm/yy" yearNavigator yearRange="2021:2070" />
                                </div>
                                <div className="col-12 md:col-2">
                                    <Calendar value={this.state.pd2} onChange={(e) => this.setState({ pd2: e.value }, () => {
                                        this.get_liste_data();
                                    })} view="month" dateFormat="mm/yy" yearNavigator yearRange="2021:2070" />
                                </div>
                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'Acteur', value: 'Tous' }].concat(this.state.listeprest)} placeholder='Acteur'  optionLabel='label' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.ridPrest} onChange={e => this.setState({ ridPrest: e.value }, () => {
                                        this.get_liste_data();
                                        this.get_liste_facture_by_prest(this.state.ridPrest)
                                    })} />
                                </div>
                                <div className="col-12 md:col-2">
                                    <Dropdown autoWidth={false} options={[{ label: 'Factures', value: 'Tous' }].concat(this.state.listeobj)} optionLabel='label' placeholder='Factures' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.ridObj} onChange={e => this.setState({ ridObj: e.value }, () => {
                                        this.get_liste_data();
                                    })} />
                                </div>
                                <div className="col-12 md:col-2">
                                    <div className="inputgroup">
                                        <SplitButton label="Rechercher" style={{ width: '140px' }} onClick={(e) => this.get_liste_data()} icon="pi pi-search" model={this.state.items}></SplitButton>
                                    </div>
                                </div>
                                <div className="col-12 md:col-1">
                                    <div className="inputgroup">
                                        {this.state.showindicator ? <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" /> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DataTable value={this.state.liste_data} selection={this.state.liste_selectedFacture} onSelectionChange={e => this.setState({ liste_selectedFacture: e.value })} header={hTotal}
                    responsive={true} paginator={true} rows={20} paginatorPosition="top" alwaysShowPaginator={false}  csvSeparator=";" ref={(el) => { this.dt = el; }} className="p-datatable-gridlines p-datatable-striped p-datatable-md p-datatable-customers" >
                    <Column field="idRgl" header="No reçu" style={{ width: '10%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="dateRgl" header="Date" style={{ width: '8%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="idObj" header="Facture" body={(rowData, column) => {
                        return <div>
                            <span style={{}}>No {rowData.idObj} {rowData.periodeObj}</span><br />
                        </div>
                    }} filter={true} filterMatchMode='contains' sortable={true} style={{ width: '12%' }} />
                    <Column field="nomPrest" header="Acteur" filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="montantRgl" header="Montant" body={(rowData, column) => {
                        return <div>
                            <span style={{ color: 'green', fontWeight: 'bold' }}>{this.FbrService.formaterValueSep(parseFloat(rowData.montantRgl))}</span>
                        </div>
                    }} sortable={true} style={{ width: '10%' }} filter={true} filterMatchMode='contains' />
                    <Column field="modeRgl" header="Mode" style={{ width: '10%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="refRgl" header="Référence" style={{ width: '13%' }} filter={true} filterMatchMode='contains' sortable={true} />
                    <Column field="prefectureSite" header="Préfecture" style={{ width: '12%' }} filter={true} filterMatchMode='contains' sortable={true} />
                </DataTable>
            </div>
        );
    }
}